import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { ModelNotifier } from "../../scripts/model-notifier";
import { NodeTypesTreeBuilder } from "../edit-node-data-dialog/ah.mb.ui.node-types-tree";
import { VariableTree } from "../../scripts/ah.mb.ui.variable-tree";
import { ExportDefinitionServices, IExportDefinition } from "../../scripts/export-definition-services";
import { ITagObject } from "../../entities/tag-object";
import { IExportNodeDataModel } from "../../entities/export-node-data-model";

@Component
export default class ExportNodeDataDialog extends Vue {

    @Prop()
    value: IExportNodeDataModel;

    private theNodeDataExportVariableTree: Fancytree.Fancytree;
    private modelServices = new modelServices(new ModelNotifier());
    private theNodeTypeTree: Fancytree.Fancytree;
    exportDefinitionServices = new ExportDefinitionServices(this.modelServices);

    selectedExportDefinition: IExportDefinition =null;

    mounted() {
        this.modelIdChanged();
        this.refreshExportDefinitionsList();
    }

    @Watch("value.nodePathAndName", { deep: false })
    nodePathAndNameCanged() {
        if (this.value && this.value.modelId && this.value.nodePathAndName) {
            this.setupView(this.value.modelId, this.value.nodePathAndName);
        }
    }

    @Watch("value.modelId", { deep: false })
    modelIdChanged() {
        if (this.value && this.value.modelId && this.value.nodePathAndName) {
            this.setupView(this.value.modelId, this.value.nodePathAndName);
        }
    }

    canExecute: boolean = false;
    selectionInfoText: string = "0 variables selected";

    // Tag testing
    tag: string = "";
    tagAutoCompleteDebounce = null;
    tags: ITagObject[] = [];

    nodeTagAutocompleteItems: Array<ITagObject> = [];
    excludeTag: string = "";
    excludeTags: ITagObject[] = [];

    exportDefinitionsList: Array<IExportDefinition> = [];

    // Node types received func
    nodeTypesReceived(nodeTypes) {


        // Build tree with variables
        const treeBuilder = new NodeTypesTreeBuilder();

        // Clear variables
        if (this.theNodeDataExportVariableTree)
            this.theNodeDataExportVariableTree.reload([]);

        this.theNodeTypeTree = treeBuilder.drawTree(
            nodeTypes.nodes,
            "#nodeDataExportNodeTypeTreeDiv",
            null, //modelEventsObservable,
            (e, data) => {
                // Node activate handler

                // A DynaTreeNode object is passed to the activation handler
                // Note: we also get this event, if persistence is on, and the page is reloaded.

                // Do not do this for the root level

            },
            null,
            null,
            this.nodeTypesTreeSelectionChanged
        );


    }

    /**
 * Gets selected nodes
 * @param recurse Not yet implemented
 */
    getSelectedNodeTypes(): Array<string> {


        var nodes = this.theNodeTypeTree.getSelectedNodes()
            .filter(theNode => !theNode.isFolder());

        var result = nodes.map(node => { return node.title });

        const selected = this.theNodeTypeTree.getActiveNode();
        if (selected)
            result.push(selected.title);

        // If not multi selected, need to specify the single node selected
        //if (result.length === 0) {
        //}

        return result;
    }

    nodeTypesTreeSelectionChanged(e, data): Promise<any> {

        var selectedNodes = this.getSelectedNodeTypes();

//        var nodeTypes = [];

        //console.log(selectedNodes);

        if (selectedNodes.length > 0 && (!data || !data.node.isFolder()))
            return this.modelServices.getNodeTypeVariablesTree(this.value.modelId,
                    selectedNodes)
                .then(response => this.nodeTypeVariablesReceivedFunc(response));

        return Promise.resolve();
        //$("#executeNodeDataExportButton").toggleClass("disabled", selectedNodes.length === 0);
//        this.selectionInfoText = selectedNodes.length.toString() + " variables selected";
        //        $("#selectVariablesToExportLabel").text();

    };


    treeSelectionChangedHandler(e, data) {

        // Select children 
        if (data && data.node.isFolder())
            data.node.children.forEach(theNode => {
                theNode.setSelected(data.node.selected);
            });


        const selectedNodes = this.theNodeDataExportVariableTree.getSelectedNodes()
            .filter(theNode => !theNode.isFolder());


        this.canExecute = true;
        //$("#executeNodeDataExportButton").toggleClass("disabled", selectedNodes.length === 0);
        this.selectionInfoText = selectedNodes.length.toString() + " variables selected";
//        $("#selectVariablesToExportLabel").text();

    };

    //nodeTypeVariablesReceived callback
    nodeTypeVariablesReceivedFunc(nodeTypeVariables) {


        // If the tree exists, have to destroy it redraw it
        if (this.theNodeDataExportVariableTree) {
            $("#nodeDataExportVariableTreeDiv").fancytree("destroy");
            $(".tree").empty();
        }

        const treeBuilder = new VariableTree();

        this.theNodeDataExportVariableTree = treeBuilder.drawTree(
            nodeTypeVariables.nodes,
            true,
            $("#nodeDataExportVariableTreeDiv"),
            null,
            () => {
                // Node activate handler

                // A DynaTreeNode object is passed to the activation handler
                // Note: we also get this event, if persistence is on, and the page is reloaded.


            },
            null,
            null,
            this.treeSelectionChangedHandler
        );

        this.canExecute = false;
        //$("#executeNodeDataExportButton").addClass("disabled");

    }

    setupModel(model: IExportNodeDataModel) {
        model.nodeTypes = this.getSelectedNodeTypes();

        // model.tags = this.tags.map(p => p.text);
        // model.excludeTags = this.excludeTags.map(p => p.text);

        let variables = this.theNodeDataExportVariableTree.getSelectedNodes()
            .filter(theNode => theNode.isSelected());

        // Exclude "All variables" etc
        variables = variables.filter(theNode => theNode.isFolder() === false);

        // Extract the variable names
        const variableNames = $.map(variables,
            theNode => theNode.title);

        model.variableNames = variableNames;

    }

    // Do export function
    doExport(model: IExportNodeDataModel) {

        this.setupModel(this.value);

        // We have to validate that the export is not too big
        this.modelServices.validateDownloadNodeData(model)
            .then(data => {
                if (data.ok) {
                    this.modelServices.downloadNodeData(model);
                } else {
                    bootbox.alert(data.response, () => {});
                }
            });

    };


    refreshExportDefinitionsList(): Promise<any> {
        return this.exportDefinitionServices.getExportDefinitions()
            .then(response => {
                this.exportDefinitionsList = response;
                return response;
            });
    }

    exportDefinitionSelected(definition: IExportDefinition) {
        this.exportDefinitionServices.getDefinition(definition.pathAndName)
            .then(response => {

                if (response) {
                    this.theNodeTypeTree.activateKey(false);

                    this.theNodeTypeTree
                        .visit(theNode => {
                            var found = response.nodeTypes.indexOf(theNode.title) > -1;
                            theNode.setSelected(found);
                            return true;
                        });
                    this.nodeTypesTreeSelectionChanged(null, null)
                        .then(() =>
                            this.theNodeDataExportVariableTree.visit(theNode => {
                                var found = response.nodeVariables.indexOf(theNode.title) > -1;
                                theNode.setSelected(found);
                                return true;
                            })
                    )

    }
            });
    }


    /**
     * Sets up the dialog
     */
    setupView(modelId: string, nodePathAndName: string) {
// Get the node types

        this.modelServices.getNodeTypes(modelId, nodePathAndName)
            .then(response => this.nodeTypesReceived(response));

    }

    exportButtonClicked() {

        this.doExport(this.value);

    }

    closeButtonClicked() {
        this.$emit("closeClicked");
    }


    saveExportDefinition() {
        bootbox.prompt({
            title: "Save Export Definition",
            content: "Definition name",
            callback: (value => {
                if (value) {

                    const variables = this.theNodeDataExportVariableTree.getSelectedNodes()
                        .filter(theNode => theNode.isSelected())
                        .map(node => node.title);
                    const nodeTypes = this.getSelectedNodeTypes();
                    this.exportDefinitionServices.saveExportDefinition(
                            value,
                            nodeTypes,
                            variables)
                        .then(response => {
                            if (response.success) {
                                this.refreshExportDefinitionsList()
                                    .then(() => {
                                        this.selectedExportDefinition =
                                        {
                                            name: value,
                                            pathAndName: `\\ExportDefinitions\\${value}}`
                                        };
                                    });
                            }
                        });
                }
            })
        });
    }

    deleteExportDefinition() {

        bootbox.confirm(`Delete ${this.selectedExportDefinition.name}?`,
            ok => {
                if (ok) {
                    this.exportDefinitionServices.deleteDefinition(this.selectedExportDefinition)
                        .then(response => {
                            if (response.success)
                                this.refreshExportDefinitionsList()
                            .then(() => this.selectedExportDefinition = null);
                        });
                }
            });
    }

    renameExportDefinition() {

        bootbox.prompt({
            title: "Rename Definition",
            content: this.selectedExportDefinition.name,
            callback: (value => {
                if (value) {
                    this.exportDefinitionServices.renameDefinition(this.selectedExportDefinition,
                        value)
                        .then(response => {
                            if (response.success)
                                this.refreshExportDefinitionsList()
                                    .then(() => this.selectedExportDefinition = null);
                        });

                };
            })
        });
    }

    @Watch("tag")
    tagChanged() {

        if (this.tag.length < 2) return;

        const url = `/api/1.0/nodetags/suggestions?modelId=${this.value.modelId}&searchterm=${this.tag}`;


        clearTimeout(this.tagAutoCompleteDebounce);
        this.tagAutoCompleteDebounce = setTimeout(() => {
            FetchWrapper.fetch(url, { method: "get" })
                .then(response => response.json())
                .then((response: Array<string>) => {
                    this.nodeTagAutocompleteItems = response.map(a => {
                        return { text: a };
                    });
                });
        }, 600);
    }

    onTagsChanged(tags: Array<ITagObject>) {
        this.value.tags = tags.map(p => p.text);
    }

    onExcludeTagsChanged(tags: Array<ITagObject>) {
        this.value.excludeTags = tags.map(p => p.text);
    }


}



// WEBPACK FOOTER //
// ./ClientApp/components/export-node-data-dialog/export-node-data-dialog.ts